<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
            <div id="websphereCoded">
                &copy; Coded with
                    <i class="fa fa-heart heart"></i> by
                    <a href="https://www.websphere.solutions/?ref=kobotrack_login" target="_blank">Websphere Solutions</a>.
            </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer'
  }
</script>
<style>
    #websphereCoded {
        margin: auto;
    }
</style>
